import './SearchResultItemDetails.scss'

import { clearStringAddress } from 'lib/place'
import React from 'react'

interface SearchResultItemDetailsProps {
  title: string
  highlightedSubtitle?: string
  subtitle?: string
  children?: JSX.Element | false | undefined | null
}

export default function SearchResultItemDetails({
  title,
  highlightedSubtitle,
  subtitle,
  children = false,
}: SearchResultItemDetailsProps): JSX.Element {
  return (
    <div className="SearchResultItemDetails">
      <div className="SearchResultItemDetails__title" data-testid="SearchResultItemDetails__title">
        {title}
      </div>
      <div className="SearchResultItemDetails__subtitles">
        {highlightedSubtitle !== undefined && (
          <div className="SearchResultItemDetails__subtitle--highlighted">
            {highlightedSubtitle}
          </div>
        )}
        {subtitle !== undefined && (
          <div
            className="SearchResultItemDetails__subtitle"
            data-testid="SearchResultItemDetails__subtitle"
          >
            {clearStringAddress(subtitle, title)}
          </div>
        )}
      </div>
      {children}
    </div>
  )
}
